import React from "react"
import { useEffect, useState } from "react"
import { getSolicitacaoById, Solicitacao as TSolicitacao, updateSolicitacao } from "../../services/solicitacoesService"
import { getUrl } from "aws-amplify/storage"
import { Link, useLocation, useParams } from "react-router-dom"
import CircularIndeterminate from "../CircularProgress"
import { Box, Button, Chip, CircularProgress, Divider, Grid, Paper, TextField, Typography } from "@mui/material"
import { Download, Send, Warning } from "@mui/icons-material"
import RadioGroupRating from "../Rating"
import CustomizedSteppers from "../Status"
import Controle from "../Controle"
import { SnackbarProvider, useSnackbar } from "notistack"

import muitoSatisfeito from '../Rating/assets/apaixonado.png';
import satisfeito from '../Rating/assets/feliz.png';
import neutro from '../Rating/assets/confuso.png';
import insatisfeito from '../Rating/assets/triste.png';
import muitoInsatisfeito from '../Rating/assets/bravo.png';

export default function Solicitacao() {

    const { id } = useParams<'id'>()
    const { enqueueSnackbar } = useSnackbar();
    const [solicitacoes, setSolicitacoes] = useState<TSolicitacao | null | undefined>(undefined)
    const [linkToAnexo, setLinkToAnexo] = useState<string | null>(null);
    const [linkToAditivo, setLinkToAditivo] = useState<string | null>(null);
    const [linkToRelatorio, setLinkToRelatorio] = useState<string | null>(null);
    const [loading, setLoading] = useState(true)
    const [loadingAvaliar, setLoadingAvaliar] = useState(false)
    const location = useLocation()
    const isControleVisible = location.pathname.startsWith('/gerenciamento/detalhes/');
    const isAvaliacaoVisible = location.pathname.startsWith('/minhassolicitacoes/detalhes/')

    const [nota, setNota] = useState(0)
    const [feedback, setFeedback] = useState('')

    const getCurrentDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
    
        return `${yyyy}-${mm}-${dd}`;
    };
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getSolicitacaoById(String(id));
                setSolicitacoes(data); // data pode ser null
    
                if (data?.arquivo_anexo) {
                    const result = await getUrl({
                        path: data.arquivo_anexo,
                        options: {
                            expiresIn: 300
                        }
                    });
                    setLinkToAnexo(result.url.toString());
                    console.log(data.arquivo_anexo)
                } else {
                    console.warn('Nenhum arquivo anexo encontrado.');
                }

                if (data?.arquivo_aditivo) {
                    const result = await getUrl({
                        path: data.arquivo_aditivo,
                        options: {
                            expiresIn: 300
                        }
                    });
                    setLinkToAditivo(result.url.toString());
                    console.log(data.arquivo_aditivo)
                } else {
                    console.warn('Nenhum arquivo aditivo encontrado.');
                }

                if (data?.arquivo_relatorio) {
                    const result = await getUrl({
                        path: data.arquivo_relatorio,
                        options: {
                            expiresIn: 300
                        }
                    });
                    setLinkToRelatorio(result.url.toString());
                    console.log(data.arquivo_relatorio)
                } else {
                    console.warn('Nenhum arquivo relatorio encontrado.');
                }

            } catch (error) {
                console.error('Failed to fetch solicitacoes', error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, [id]);  

    const handleUpdateSolicitacao = async (updatedFields: Partial<TSolicitacao>): Promise<void> => {
        if (!solicitacoes) {
            console.error('No solicitacao data available to update.');
            return;
        }

        const updatedSolicitacao: TSolicitacao = {
            ...solicitacoes,
            ...updatedFields,
        };

        try {
            const updatedData = await updateSolicitacao(updatedSolicitacao);
            setSolicitacoes(updatedData);
        } catch (error) {
            console.error('Failed to update solicitacao', error);
        }
    };

    const handleAvaliar = async () => {
        try {
            setLoadingAvaliar(true)
            await handleUpdateSolicitacao({
                status: 5,
                nota: nota,
                feedback: feedback,
                data_conclusao: getCurrentDate()
            })

            enqueueSnackbar('Avaliação enviada!', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar('Ocorreu um erro ao enviar.', { variant: 'error' });
        } finally {
            setLoadingAvaliar(false)
        }
    }

    const formatDate = (dateString: string) => {
        // Divide a string de data em partes
        const [ano, mes, dia] = dateString.split('-');
        
        // Formata a data com os valores obtidos
        return `${dia}/${mes}/${ano}`;
    };
    
    if (loading) {
        return <CircularIndeterminate />
    }
    
    return(
        <SnackbarProvider>
        <>
            {solicitacoes && (
                <>
                {isControleVisible === true ? ( 
                    <Controle 
                        n_solicitacao={solicitacoes.n_solicitacao} 
                        status={solicitacoes.status}
                        onUpdate={handleUpdateSolicitacao}
                        email={solicitacoes.email} 
                    />) : (
                        <>
                        <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item xs={6}>
                                    <Typography variant="h6" fontWeight={700}>
                                        Acompanhamento da solicitação
                                    </Typography>
                                    <Typography variant="h6">{solicitacoes.n_solicitacao}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        </>
                    )
                }
                <Paper elevation={3} style={{ padding: '20px', margin: '20px', minHeight: '80vh', marginBottom: '160px' }}>
                    <Grid container spacing={1}>
                        <Grid container item spacing={2}>
                            <Grid item xs={4} >
                                <Typography variant="h6" fontWeight={700} >Solicitante</Typography>
                            </Grid>
                            <Grid item xs={4} >
                                <Typography variant="h6" fontWeight={700} >Data da solicitação</Typography>
                            </Grid>
                            <Grid item xs={4} >
                                <Typography variant="h6" fontWeight={700} >Projeto</Typography>
                            </Grid>
                        </Grid>

                        <Grid container item spacing={2}>
                            <Grid item xs={4} >
                                <Typography variant="subtitle1" padding={1} style={{ background: '#10427F', color: 'white', borderRadius: '10px' }}>{solicitacoes.nome}</Typography>
                            </Grid>
                            <Grid item xs={4} >
                                <Typography variant="subtitle1" padding={1} style={{ border: '1px solid #D1D1D1', borderRadius: '10px' }} >{formatDate(solicitacoes.data_solicitacao)}</Typography>
                            </Grid>
                            <Grid item xs={4} >
                                <Typography variant="subtitle1" padding={1} style={{ border: '1px solid #D1D1D1', borderRadius: '10px' }}>{solicitacoes.projeto}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container item spacing={1} marginTop={2}>
                            <Grid item xs={12}>
                                <Typography variant="h6" fontWeight={700} >Informações da amostra</Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>ID Amostra</Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Material</Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Análise</Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Preparo de Amostra</Typography>
                            </Grid>
                        </Grid>

                        <Grid container item spacing={1}>
                            {Array.isArray(solicitacoes.amostras)
                                ? solicitacoes.amostras.map((amostra, index) => (
                                    <React.Fragment key={index}>
                                    <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle1" align="center" borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>
                                        {amostra.id_amostra}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle1" align="center" borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>
                                        {amostra.material}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', border: '1px solid #D1D1D1', borderRadius: '4px', padding: '4px' }}>
                                        {amostra.analise.map((item: string, i: React.Key | null | undefined) => (
                                            <Chip key={i} label={item.trim()} style={{ margin: '2px' }} />
                                        ))}
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle1" align="center" borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>
                                        {amostra.preparo}
                                        </Typography>
                                    </Grid>
                                    </React.Fragment>
                                ))
                                : null}
                            </Grid>
                        <Grid container item spacing={1} marginTop={2}>
                            <Grid item xs={12}>
                                <Typography variant="h6" fontWeight={700} >Mais informações</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Objetivo</Typography>
                                <Typography variant="subtitle1" align="center" marginTop={1} borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>{solicitacoes.objetivo}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginTop={1}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Destino pós teste</Typography>
                                <Typography variant="subtitle1" align="center" marginTop={1} borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>{solicitacoes.destino}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginTop={1}>
                                <Typography variant="subtitle1" align="center" fontWeight={700} borderRadius={1} style={{ background: '#B3B3B3', color: 'white' }}>Observações</Typography>
                                {solicitacoes.observacoes && (
                                    <Typography variant="subtitle1" align="center" marginTop={1} borderRadius={1} padding={1} style={{ border: '1px solid #D1D1D1' }}>{solicitacoes.observacoes}</Typography>
                                )}
                            </Grid>
                        </Grid>

                        <Grid container item spacing={1} marginTop={2}>
                            <Grid item xs={12} sm={4} md={3} lg={2}>
                                <Typography variant="h6" fontWeight={700}>Anexo</Typography>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    endIcon={<Download />}
                                    style={{ 
                                        background: linkToAnexo ? '#10427F' : '#bdbdbd',
                                        color: linkToAnexo ? '#fff' : '#9e9e9e', 
                                    }}
                                    disabled={!linkToAnexo} 
                                    component="a"
                                    href={linkToAnexo || '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                >
                                    Baixar arquivo
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} lg={2}>
                                <Typography variant="h6" fontWeight={700}>Termo aditivo</Typography>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    endIcon={<Download />}
                                    style={{ 
                                        background: linkToAditivo ? '#10427F' : '#bdbdbd',
                                        color: linkToAditivo ? '#fff' : '#9e9e9e', 
                                    }}
                                    disabled={!linkToAditivo} 
                                    component="a"
                                    href={linkToAditivo || '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                >
                                    Baixar arquivo
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} lg={2}>
                                <Typography variant="h6" fontWeight={700}>Relatório</Typography>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    endIcon={<Download />}
                                    style={{ 
                                        background: linkToRelatorio ? '#10427F' : '#bdbdbd',
                                        color: linkToRelatorio ? '#fff' : '#9e9e9e', 
                                    }}
                                    disabled={!linkToRelatorio} 
                                    component="a"
                                    href={linkToRelatorio || '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                >
                                    Baixar arquivo
                                </Button>
                            </Grid>
                        </Grid>

                        {solicitacoes.status === 4 && isAvaliacaoVisible ? (
                        <Grid container item spacing={1} marginTop={2}>
                            <Grid item xs={12}>
                                <Divider sx={{ marginTop: 3, marginBottom: 2 }} />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }} marginBottom={2}>
                                <Typography variant="h6" fontWeight={700}>Qual é o seu nível de satisfação com esse serviço?</Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }} marginBottom={1}>
                                <RadioGroupRating onChange={(newNota) => setNota(newNota)}/>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <TextField placeholder='Comentário' fullWidth multiline onChange={(e) => setFeedback(e.target.value)}  />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right' }} marginTop={1}>
                                <Button variant="contained" endIcon={<Send />} style={{ background: '#10427F' }} onClick={handleAvaliar}>
                                    {loadingAvaliar ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
                                </Button>
                            </Grid>
                        </Grid>
                        ) : null}

                        {solicitacoes.status === 5 ? (
                            <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12}>
                              <Divider sx={{ marginTop: 3, marginBottom: 2 }} />
                            </Grid>
                            
                            <Grid item xs={12}>
                              <Typography variant="h6" marginLeft={1} marginBottom={1} fontWeight={700}>Pesquisa de Satisfação</Typography>
                            </Grid>
                            
                            <Grid item container xs={12} alignItems="center" spacing={2}>
                              <Grid item marginLeft={1}>
                                <img src={solicitacoes.nota === 1 ? muitoInsatisfeito
                                    : solicitacoes.nota === 2 ? insatisfeito
                                    : solicitacoes.nota === 3 ? neutro
                                    : solicitacoes.nota === 4 ? satisfeito
                                    : solicitacoes.nota === 5 ? muitoSatisfeito : undefined
                                } width="50px" />
                              </Grid>
                              <Grid item>
                                <Typography variant="button" fontSize={18}>
                                  {solicitacoes.nota},0 - {solicitacoes.nota === 1 ? "Muito insatisfeito"
                                    : solicitacoes.nota === 2 ? "Insatisfeito"
                                    : solicitacoes.nota === 3 ? "Neutro"
                                    : solicitacoes.nota === 4 ? "Satisfeito"
                                    : solicitacoes.nota === 5 ? "Muito satisfeito" : null
                                  }
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} marginLeft={1}>
                              <Typography variant="body1"><strong>Comentário:</strong> {solicitacoes.feedback}</Typography>
                            </Grid>
                          </Grid>
                          
                        ) : null}
                    </Grid>
                </Paper>
                <Paper
                    variant="elevation"
                    elevation={24}
                    component="footer"
                    sx={{
                        width: '100%',
                        position: 'fixed',
                        bottom: 0,
                        backgroundColor: 'white',
                        
                        py: 2,
                    }}
                >
                    {solicitacoes.status === 999 ? (
                        <Box padding={2}>
                            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Warning color="error" sx={{ fontSize: 60 }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="button" color="error">
                                                Solicitação Recusada
                                            </Typography>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                <strong>Motivo:</strong> {solicitacoes.motivo_rejeicao}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {isAvaliacaoVisible && (
                                    <Grid item>
                                        <Link to={`editar`}>
                                            <Button variant="outlined" style={{color:'#10427F', borderColor: '#10427F' }}>
                                                Fazer correções
                                            </Button>
                                        </Link>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    ) : 
                        <CustomizedSteppers 
                            activeStep={solicitacoes.status}
                            dataSolicitacao={solicitacoes.data_solicitacao} 
                            dataAceite={solicitacoes.data_aprovacao}
                            dataRelatorio={solicitacoes.data_relatorio}
                            dataPesquisa={solicitacoes.data_pesquisa}
                            dataFinalizado={solicitacoes.data_conclusao}
                        />
                    }
                    
                </Paper>
            </>
            )}
        </>
        </SnackbarProvider>
    )
}